<template>
  <div>
    <main-header></main-header>
    <div class="main">
      <div v-for="section in homesections" :key="section.name">
        <h3>{{section.name}}</h3>
        <ul class="link clearfix" style="min-height: 160px">
          <li v-for="link in section.links" :key="link.url" @mouseenter="hover($event,true)" @mouseleave="hover($event,false)" :title="link.name">
            <router-link v-if="link.type==='app'" :to="link.url" class="iconfont img-icon" :style="getRandomColor(link)">
              <span class="bottom-text">{{link.name==='KeyBoard'?'Answer.AI':link.name}}</span>
            </router-link>
            <a v-else-if="['tool', 'service'].indexOf(link.type) > -1" :href="link.url" class="iconfont img-icon" :class="getClass(link.name)" :style="getRandomColor()" target="_blank">
              <span class="bottom-text">{{link.label||label.name}}</span>
            </a>
            <router-link v-else :to="link.url" class="iconfont" :class="link.iconClass" :style="getRandomColor()">
              {{link.name}}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import MainHeader from '@/components/header.vue'

  const tools = [
    {
      name: 'Airflow',
      label: 'Airflow',
      type: 'tool',
      url: 'http://airflow.answeraiops.com'
    },
    {
      name: 'Superset',
      label: 'Superset',
      type: 'tool',
      url: 'http://superset.answeraiops.com'
    },
    {
      name: 'Tableau',
      label: 'Tableau',
      type: 'tool',
      url: 'http://tableau.answeraiops.com'
    },
    // {
    //   name: 'Flurry',
    //   label: 'Flurry',
    //   type: 'tool',
    //   url: 'https://dev.flurry.com'
    // },
    // {
    //   name: 'Firebase',
    //   label: 'Firebase',
    //   type: 'tool',
    //   url: 'https://console.firebase.google.com/'
    // },
    // {
    //   name: 'Analytics',
    //   label: 'Analytics',
    //   type: 'tool',
    //   url: 'https://analytics.google.com/analytics/web/'
    // },
    // {
    //   name: 'Appsflyer',
    //   label: 'Appsflyer',
    //   type: 'tool',
    //   url: 'https://www.appsflyer.com/'
    // },
    // 增加腾讯云数据湖(https://console.cloud.tencent.com/dlc/data-exploration)、Adjust(https://suite.adjust.com/)图标
    {
      name: 'TencentCloud',
      label: '腾讯云数据湖',
      type: 'tool',
      url: 'https://console.cloud.tencent.com/dlc/data-exploration'
    },
    {
      name: 'Adjust',
      label: 'Adjust',
      type: 'tool',
      url: 'https://suite.adjust.com/'
    }

  ] 

  const services = [
    {
      name: 'IPLocation',
      type: 'service',
      url: '#/service/iplocation',
    },
    {
      name: 'GeoLocation',
      type: 'service',
      url: '#/service/geolocation',
    },
    {
      name: 'MobilePrice',
      type: 'service',
      url: '#/service/mobile/price',
    },
    {
      name: 'Currency',
      type: 'service',
      url: '#/service/currency',
    }
  ]

  export default {
    components:{MainHeader},
    data () {
      return {
        homesections:[]
      }
    },
    mounted() {
      this.$http.get("/ams/admin/page?page_id=0").then(res => {

        let children = res.data.page.children || []
        children.sort((a, b) => a.sort - b.sort)

        let homesections = children.map(v => {
          var section = {
            name: v.name,
            url: v.url,
            links: []
          };
          return section;
        })
        homesections.map(v => {
          if (v.url == '/manage') {
            this.$http.get('/ams/admin/info').then(res => {
              let adminInfo = res.data.data;

              if ((adminInfo.roles || []).length > 0) {
                let info = JSON.parse(localStorage.getItem('userinfo'));
                info.role = adminInfo.roles[0].name;
                localStorage.setItem('userinfo',JSON.stringify(info));
              }

              let sysApps = {};

              (adminInfo.apps || []).forEach((app) => {
                let s = app.system || app.name;
                sysApps[s] = sysApps[s] || [];
                sysApps[s].push(app);
              })

              let links = Object.keys(sysApps).map(sys => {
                let app = sysApps[sys][0];
                return {
                  name: app.system || app.name,
                  type: 'app',
                  url: `/app/${sys}`,
                  iconClass: 'icon-apps',
                  icon: app.icon,
                }
              })

              v.links = links;

            })
          } else {
            this.$http.get("/ams/admin/page?limit=50&scope=true&url=" + v.url).then(res => {
              v.links = (res.data.page.children || []).filter((c) => c.url != "").map(v1 => {
                return {
                  name: v1.name,
                  url: v1.url,
                  iconClass: this.setclass(v1.name)
                }
              })
            });
          }
        })

        // homesections.push({
        //   url: '/services',
        //   name: 'SERVICES',
        //   links: services
        // })

        homesections.push({
          url: '/tools',
          name: 'TOOLS',
          links: tools
        })

        this.homesections = homesections;

      });

    },
    methods:{
      setclass(v){
        if(v=="权限管理"){return 'icon-quanxian'}
        if(v=="APP管理"){return 'icon-apps'}
        if(v=="配置管理"){return 'icon-config'}
        if(v=="运维数据"){return 'el-icon-s-data'}
        if(v=="对话查询"){return 'el-icon-chat-dot-square'}
        if(v=="数据表监控"){return 'el-icon-monitor'}
      },
      getRandomColor(link){

        var rgb = parseInt((Math.random()+0.8)*100)+','+parseInt((Math.random()+0.8)*100)+','+parseInt((Math.random()+0.8)*100)

        let style = {
          backgroundColor: `rgba(${rgb}, 0.1)`,
          color: `rgb(${rgb})`
        }

        if (link && link.type == 'app') {
          style.backgroundImage = `url("${link.icon}")`
        }

        return style;

      },
      getClass(name) {
        return `${name.toLowerCase()}-icon`
      },
      hover(obj,boo){
        var bg = obj.target.childNodes[0].style.backgroundColor
        obj.target.childNodes[0].style.backgroundColor = boo ? bg.replace('0.1','0.9') : bg.replace('0.9','0.1')
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '@/assets/css/varible.less';
  .main{
    padding: 30px;
  }
  h3{
    margin-left: 20px;
    font-size: 20px;
    font-family: 'iconfont';
  }
  .img-icon {
    margin: 0 auto;
    background-repeat: no-repeat;
    background-size: 70px;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    padding-bottom: 10px;
  }
  .aws-icon {
      background-image: url(../assets/imgs/aws.png);
  }
  .airflow-icon {
      background-image: url(../assets/imgs/airflow.png);
  }
  .gitlab-icon {
      background-image: url(../assets/imgs/gitlab.png);
  }
  .superset-icon {
      background-image: url(../assets/imgs/superset.png);
  }
  .tableau-icon {
      background-image: url(../assets/imgs/tableau.svg);
  }
  .analytics-icon {
      background-image: url(../assets/imgs/ic_analytics.svg);
  }
  .firebase-icon {
      background-image: url(../assets/imgs/firebase.png);
  }
  .appsflyer-icon {
      background-image: url(../assets/imgs/appsflyer.svg);
  }
  .grafana-icon {
      background-image: url(../assets/imgs/grafana.svg);
  }
  .flurry-icon {
      background-image: url(../assets/imgs/flurry.png);
  }
  .iplocation-icon {
      background-image: url(../assets/imgs/iplocation.png);
  }
  .geolocation-icon {
      background-image: url(../assets/imgs/geolocation.png);
  }
  .mobileprice-icon {
      background-image: url(../assets/imgs/mobileprice.png);
  }
  .currency-icon {
      background-image: url(../assets/imgs/currency.png);
  }
  .tencentcloud-icon {
      background-image: url(../assets/imgs/tencent-cloud.png);
  }
  .adjust-icon {
      background-image: url(../assets/imgs/adjust.png);
  }

  li{
    float: left;
    padding:15px;
    text-align: center;
    width: 10%;
    /* width:12.5%; */
    min-width: 150px;
    @media (max-width:1600px){
      width: 8%;
    }
    @media (max-width:1280px){
      width: 8%;
    }
  }
  .bottom-text {
    width: 100%;
    /* background-color: rgb(217, 236, 255); */
    line-height: 30px;
    position: relative;
    top: 10px;
  }
  .iconfont{
    width: 110px;
    height: 110px;
    line-height: 1;
    padding-top: 8px;
    border-radius: 8px;
    font-size: 18px;
    color: #fff;
    text-align: center;
    transition: all .3s;
    overflow: hidden;
    &::before{
      display: block;
      height: 70px;
      line-height: 70px;
      font-size: 55px;
    }
  }
  .iconfont:hover{
    color:#fff!important;
  }
  li:hover {
    a{
    color:#fff!important;
    }
  }
</style>
